export const StationDetailConstant = {

    
    BASIC_DETAIL_SAGA: "BASIC_DETAIL_SAGA",
    BASIC_DETAIL_REQUEST: "BASIC_DETAIL_REQUEST",
    BASIC_DETAIL_RESPONSE: "BASIC_DETAIL_RESPONSE",
    BASIC_DETAIL_API: "/vendor/charging-station/:id",

    CHARGING_ENABLE_DISABLE_SAGA: "CHARGING_ENABLE_DISABLE_SAGA",
    CHARGING_ENABLE_DISABLE_REQUEST: "CHARGING_ENABLE_DISABLE_REQUEST",
    CHARGING_ENABLE_DISABLE_RESPONSE: "CHARGING_ENABLE_DISABLE_RESPONSE",
    CHARGING_ENABLE_DISABLE_API: "/charging-point/enable-disable-connector",

    CHARGING_POINT_DELETE_SAGA: "CHARGING_POINT_DELETE",
    CHARGING_POINT_DELETE_REQUEST: "CHARGING_POINT_DELETE_REQUEST",
    CHARGING_POINT_DELETE_RESPONSE: "CHARGING_POINT_DELETE_RESPONSE",
    CHARGING_POINT_DELETE_API: "/charging-point/delete-connector/:id",



    CHARGING_POINT_ENABLE_DISABLE_SAGA: ".CHARGING_POINT_ENABLE_DISABLE_SAGA",
    CHARGING_POINT_ENABLE_DISABLE_REQUEST: "CHARGING_ENABLE_DISABLE_REQUEST",
    CHARGING_POINT_ENABLE_DISABLE_RESPONSE: "CHARGING_ENABLE_DISABLE_RESPONSE",
    CHARGING_POINT_ENABLE_DISABLE_API: "/enable-disable-chargingpoint",




};